require('./nav-sponsorship.scss');
var helper = require('./nav-sponsorship.js');
var eventToolbox = require('src/interlock/no-ui/utils/event-toolbox/event-toolbox');
var sponsorshipConstants = require('./constants');
var responsiveToolkit = require('src/interlock/no-ui/utils/responsive-bootstrap-toolkit/responsive-bootstrap-toolkit');

var requestData = {
        'userId': window.EDM.visitor.id || '',
        'timeStamp': window.EDM.PageValues.page.timestamp || '',
        'pageName': window.EDM.PageValues.page.name || ''
    },
    vehicle,
    firstDropdown = true;
var darklaunch = require('src/interlock/no-ui/utils/darklaunch/darklaunch');

function attachEvent(vehicle) {
    eventToolbox.subscribeCustomEvent(sponsorshipConstants.EVENT_TYPE_FIRE_IMPRESSION_TRACKING, function(e, data) {
        var isMobile = responsiveToolkit.is('<=sm') ? true : false;
        helper.fireImpressionTracking(vehicle, isMobile, data);
    });
    eventToolbox.subscribeCustomEvent('small-mmy-drawer-opened', function() {
        window.EDMDataStorage['vehicle'] = vehicle;
    });
}

function setRandomVehicle(textStatus, types) {
    if (textStatus === 'success') {
        vehicle = types === null ? helper.getRandomVehicle('default') : helper.getRandomVehicle(types[0]);
    } else {
        vehicle = helper.getRandomVehicle('default');
    }
}

function processNavSponsorship(jqXHR, textStatus) {
    if(jqXHR.types && isEnabledSegment(jqXHR.types[0])){
        $('.sponsorship-item').each(function(){
            appendNavAdToContainer(this);
        });
        appendNavAdToContainer();//call for drawer
    } else {
        setRandomVehicle(textStatus, jqXHR.types);
        helper.appendImageToHeader(vehicle);

        attachEvent(vehicle);
        $('.navbar-menu').on('click', function () {
            if(darklaunch.storyEnabled('TMT-207')) {
                if(firstDropdown) {
                    firstDropdown = false;
                } else {
                    eventToolbox.fireCustomEvent(sponsorshipConstants.EVENT_TYPE_FIRE_IMPRESSION_TRACKING, {});
                }
            } else {
                eventToolbox.fireCustomEvent(sponsorshipConstants.EVENT_TYPE_FIRE_IMPRESSION_TRACKING, {});
            }
        });

        if (requestData.pageName === 'home_page') {
            helper.setSponsorshipExampleMakeHP();
            helper.setSponsorshipExampleModelHP(vehicle);

            if (!darklaunch.storyEnabled('TMT-207')) {
                eventToolbox.fireCustomEvent(sponsorshipConstants.EVENT_TYPE_FIRE_IMPRESSION_TRACKING,
                    {tabId: '#' + sponsorshipConstants.NAV_ITEMS[0]});
            }
        }

        if(darklaunch.storyEnabled('TMT-207')) {
            eventToolbox.fireCustomEvent(sponsorshipConstants.EVENT_TYPE_FIRE_IMPRESSION_TRACKING,
                {tabId: '#' + sponsorshipConstants.NAV_ITEMS[0]});
        }
    }
}

function appendNavAdToContainer(container) {
    container = container || '.sponsorship-item-small';
    $(container).find('.punit-wrapper > div').addClass('punit').asyncGptTag({});
}

function isEnabledSegment(type) {
    return (type === 'crossover' && $('.sponsorship-item').first().hasClass('wtf-nav-ad'));
}

if (requestData.userId && requestData.timeStamp && requestData.pageName && helper.hasSponsorshipData()) {
    $.ajax({
        type: 'POST',
        url: '//udm.edmunds.com/api/segment',
        contentType: 'application/json',
        data: JSON.stringify(requestData),
        dataType: 'json'
    }).always(processNavSponsorship);
}



//////////////////
// WEBPACK FOOTER
// ./src/interlock/nav-sponsorship/index.js
// module id = 65
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14